import { createFileRoute } from '@tanstack/react-router';

import { AuditReportsPage } from '@/features/audit-workflow/components/AuditReportsPage';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/audit/reports')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.auditReports'),
  }),
  component: AuditReportsRoute,
});

function AuditReportsRoute() {
  return <AuditReportsPage />;
}
